import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Box, Search, ChevronRight, Truck } from 'lucide-react';

const ReceivingList = () => {
  const [pos, setPos] = useState([]);
  const navigate = useNavigate();
  const session = JSON.parse(localStorage.getItem('user') || '{}');
  const sessionSite = session.site_id || '';
  const sessionOrg = session.org_id || ''; 
  
  useEffect(() => {
    // ??? ??? POs ???????? ??? ????? ??? ????? ??????? ????????
    axios.get(`/api/po/pending-receipts/${sessionOrg}`)
      .then(res => setPos(res.data));
  }, []);

  return (
    <div className="flex flex-col h-full bg-[#f3f4f6] text-[11px] font-sans">
      <div className="bg-white p-3 border-b shadow-sm">
        <h2 className="text-[#005495] font-black italic uppercase text-lg flex items-center gap-2">
          <Truck size={20} /> Receiving & Inspection
        </h2>
      </div>

      <div className="p-4 grid grid-cols-1 gap-3">
        {pos.map(po => (
          <div key={po.ponum} onClick={() => navigate(`/receiving/${po.ponum}`)}
            className="bg-white border rounded p-4 flex justify-between items-center hover:border-blue-500 cursor-pointer shadow-sm transition-all group">
            <div className="flex gap-6">
              <div className="flex flex-col">
                <span className="text-gray-400 font-bold uppercase text-[9px]">PO Number</span>
                <span className="font-black text-blue-900 text-sm">{po.ponum}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-gray-400 font-bold uppercase text-[9px]">Vendor</span>
                <span className="font-bold text-gray-700">{po.vendor}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-gray-400 font-bold uppercase text-[9px]">Description</span>
                <span className="text-gray-600 italic">{po.description}</span>
              </div>
            </div>
            <ChevronRight className="text-gray-300 group-hover:text-blue-500" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReceivingList;